import api from './api';

export type NoteListItem = {
  id: string;
  dateIso: string | null;
  title: string;
  participants: string[];
  meetingGoogleId: string;
};

export type NoteDetails = NoteListItem & {
  content: string;
};

export async function listNotes(): Promise<NoteListItem[]> {
  const res = await api.get('/notes');
  return (res.data && res.data.data) || [];
}

export async function getNote(id: string): Promise<NoteDetails | null> {
  const res = await api.get(`/notes/${encodeURIComponent(id)}`);
  return (res.data && res.data.success) ? (res.data.data as NoteDetails) : null;
}

export async function generateNoteFromTranscription(meetingGoogleId: string, opts?: { prompt?: string; apiKey?: string }) {
  const body: any = { meeting_google_id: meetingGoogleId };
  if (opts?.prompt) body.prompt = opts.prompt;
  if (opts?.apiKey) body.apiKey = opts.apiKey;
  const res = await api.post('/notes/generate', body);
  return res.data?.data;
}

export type AiTaskItem = { title: string; due_date: string | null };
export async function generateAiTasks(noteId: string, opts?: { prompt?: string; apiKey?: string }): Promise<AiTaskItem[]> {
  const body: any = {};
  if (opts?.prompt) body.prompt = opts.prompt;
  if (opts?.apiKey) body.apiKey = opts.apiKey;
  const res = await api.post(`/notes/${encodeURIComponent(noteId)}/ai-tasks`, body);
  return (res.data && res.data.data && Array.isArray(res.data.data.items)) ? res.data.data.items as AiTaskItem[] : [];
}

export default {
  listNotes,
  getNote,
  generateNoteFromTranscription,
  generateAiTasks
};


